import { lazy } from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { DEFAULT_ROUTE } from '../../routing/routes.config';

const ClaimsPage = () => {
  const Dashboard = lazy(() => import('../dashboard/DashboardWrapper'));
  const ClaimsAction = lazy(() => import('./features/actions/ClaimActions'));
  const ClaimActionsEdit = lazy(() => import('./features/actions/ClaimActionsEdit'));
  const ClaimActionsNew = lazy(() => import('./features/actions/ClaimActionsNew'));
  const ClaimsShareForm = lazy(() => import('./features/actions/ClaimShareDetails'));
  const ClassLawsuitDetails = lazy(() => import('./features/actions/ClassLawsuitDetails'));
  const ClaimsActionDetails = lazy(() => import('./features/actions/ClaimActionsDetails'));
  const ClaimTransactions = lazy(() => import('./features/transactions/ClaimTransactions'));
  const ClaimTransactionsForm = lazy(() => import('./features/transactions/ClaimTransactionsForm'));
  const PortfolioList = lazy(() => import('./features/portfolio/PortfolioList'));
  const PortfolioView = lazy(() => import('./features/portfolio/PortfolioView'));
  const ClaimUploadTransactions = lazy(() => import('./features/transactions/ClaimUploadTransactions'));
  const { path } = useRouteMatch();
  
  return (
    <Switch>
      <Route path={`${path}/dashboard`} component={Dashboard}/>
      <Route exact path={`${path}/actions`} component={ClaimsAction}/>
      <Route path={`${path}/actions/new`} component={ClaimActionsNew}/>
      <Route path={`${path}/actions/edit/:id`} component={ClaimActionsEdit}/>
      <Route path={`${path}/share/edit/:id`} component={ClaimsShareForm}/>
      <Route path={`${path}/actions/details/:id`} component={ClaimsActionDetails}/>
      <Route path={`${path}/lawsuit/details/:id`} component={ClassLawsuitDetails}/>
      {/* <Route path={`${path}/lawsuit/new`} component={ClassLawsuitForm}/>
      <Route path={`${path}/lawsuit/edit/:id`} component={ClassLawsuitForm}/> */}
      <Route exact path={`${path}/portfolio`} component={PortfolioList}/>
      <Route path={`${path}/portfolio/view/:symbol/:userId?`} component={PortfolioView}/>
      <Route exact path={`${path}/transactions`} component={ClaimTransactions}/>
      <Route path={`${path}/transactions/new`} component={ClaimTransactionsForm}/>
      <Route path={`${path}/transactions/edit/:id`} component={ClaimTransactionsForm}/>
      <Route exact path={`${path}/upload-transactions`} component={ClaimUploadTransactions}/>
      <Redirect to={DEFAULT_ROUTE} />
    </Switch>
  )
}

export default ClaimsPage
